<template>
  <OverlayCard @cancel="$emit('cancel')" width="m">
    <template #title>
      {{ $t('shortcutModal.title') }}
    </template>

    <template #content>
      <div class="shortcut-modal__groups">
        <div v-for="{ label, shortcuts } in $options.shortcutlist" :key="label">
          <div class="shortcut-modal__label">
            {{ $t(`shortcutModal.${label}`) }}
          </div>

          <ul class="shortcut-modal__list">
            <li v-for="shortcut in shortcuts" :key="shortcut" class="shortcut-modal__item">
              <span class="shortcut-modal__name" v-html="$t(`shortcutModal.${replace(':', '', shortcut)}`)"></span>

              <span class="shortcut-modal__shortcut">
                <ShortcutInfo :shortcut="shortcut" />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </template>

    <template #footer>
      <Btn @click="$emit('cancel')" color="blue" shortcut="confirm">
        {{ $t('action.done') }}
      </Btn>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { replace } from 'ramda';
import { GeneralEvent } from '@/tracking/trackingTypes';
import shortcutMixin, { ShortcutConfig } from '@shortcuts/shortcutMixin';

const shortcutlist = [
  {
    label: 'creation',
    shortcuts: ['create:project', 'create:source', 'create:code', 'create:memo'],
  },
  {
    label: 'navigation',
    shortcuts: ['go:sources', 'go:codes', 'go:memos', 'go:quotations', 'go:views', 'go:settings', 'go:projects'],
  },
];

export default defineComponent({
  emits: { cancel: null },
  mixins: [shortcutMixin],
  name: 'ShortcutCard',

  shortcutlist,

  shortcuts(): ShortcutConfig {
    return {
      confirm: () => this.$emit('cancel'),
    };
  },

  methods: {
    replace,
  },

  mounted() {
    this.$tracker.track(GeneralEvent.ShortCutModalViewed);
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
.shortcut-modal__groups {
  display: grid;
  grid-gap: 48px;
}

.shortcut-modal__list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-gap: 16px;
}

.shortcut-modal__item {
  display: grid;
  grid-gap: 80px;
  grid-template-columns: 1fr min-content;
  align-items: center;
}

.shortcut-modal__shortcut {
  font-size: 16px;
}

.shortcut-modal__label {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.4px;
  color: colors.$color-text-grey;
  margin-bottom: 16px;
  text-transform: uppercase;
}
</style>
